
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4d4051ae!sass-loader?indentedSyntax&sourceMap!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./StatisticsCard6.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./StatisticsCard6.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4d4051ae!../../../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./StatisticsCard6.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/structure/ui/StatisticsCard6.vue
// module id = 2042
// module chunks = 1